import { refreshIcons } from '../../base/utils.js';

export function showToast(messageOrOptions, type = 'success') {
    let options = {};
    if (typeof messageOrOptions === 'string') {
        options = { message: messageOrOptions, type: type };
    } else {
        options = messageOrOptions;
    }

    const {
        title = '',
        message = '',
        type: toastType = 'info',
        position = 'top-right',
        duration = 5000,
        closable = true,
        variant = ''
    } = options;

    let container = document.querySelector(`.toast-container.${position}`);
    if (!container) {
        container = document.createElement('div');
        container.className = `toast-container ${position}`;
        document.body.appendChild(container);
    }

    let toastClass = 'toast';

    if (variant === 'solid') {
        toastClass += ` bg-${toastType} text-white border-0`;
    } else if (variant === 'outline') {
        toastClass += ` bg-white dark:bg-slate-800 border border-dashed border-${toastType} text-${toastType}`;
    } else if (variant === 'accent') {
        toastClass += ` toast-${toastType} border border-start-4 border-start-${toastType}`;
    } else {
        toastClass += ` toast-${toastType}`;
    }

    const toast = document.createElement('div');
    toast.className = toastClass;

    const icons = {
        success: 'check-circle',
        danger: 'alert-circle',
        warning: 'alert-triangle',
        info: 'info'
    };

    const iconName = icons[toastType] || 'info';

    toast.innerHTML = `
        <div class="toast-icon"><i data-lucide="${iconName}"></i></div>
        <div class="toast-content">
            ${title ? `<div class="toast-title">${title}</div>` : ''}
            ${message ? `<div class="toast-message">${message}</div>` : ''}
        </div>
        ${closable ? `<button type="button" class="toast-close"><i data-lucide="x" class="w-4 h-4"></i></button>` : ''}
    `;

    if (position.includes('top')) {
        container.prepend(toast);
    } else {
        container.appendChild(toast);
    }

    if (!container.contains(toast)) container.appendChild(toast);

    refreshIcons();

    void toast.offsetHeight;

    requestAnimationFrame(() => {
        toast.classList.add('show');
    });

    if (closable) {
        toast.querySelector('.toast-close').addEventListener('click', () => hideToast(toast));
    }

    if (duration > 0) {
        setTimeout(() => hideToast(toast), duration);
    }
}

function hideToast(toast) {
    toast.style.height = toast.offsetHeight + 'px';
    toast.offsetHeight;

    toast.classList.add('hiding');
    toast.classList.remove('show');

    setTimeout(() => {
        toast.remove();
    }, 300);
}
